<template>
    <div class="card summary-item">
        <div class="card-content-wrapper card-link-wrapper">
            <div class="card-body">
				<div class="card-body-content-wrapper">
					<div class="card-type" v-if="item.Type !== null">{{ item.Type.DisplayName }}</div>
					<a a v-bind:href="item.Url">
						<h2 class="card-title">
							<text-highlight :queries="queries">{{ item.Title }}</text-highlight>
						</h2>
					</a>

					<div class="breadcrumb">
						<ul class="breadcrumb-wrapper">
							<li v-for="crumb in item.Breadcrumbs">
								<text-highlight :queries="queries">{{ crumb.Title }}</text-highlight>
							</li>
						</ul>
					</div>
					<div class="card-summary" v-html="$options.filters.highlightText(item.Summary, queries)"></div>

				</div>
            </div>
        </div>
    </div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import TextHighlight from 'vue-text-highlight';

	export default {
		props: ['item'],
		data() {
            return {
                queries: [],
            };
        },
		components: {
            'text-highlight': TextHighlight
		},
		computed: mapState({
			specification: state => state.listing.specification,
		}),
		mounted: function () {
			this.queries.push(this.specification.Query);

            this.$store.subscribe((mutation, state) => {
                this.queries = [];
				this.queries.push(state.listing.specification.Query);
			});
		},
		methods: {
        },
		filters: {
			className: function (type) {
				let className = '';

				if (type !== null) {
					className = type.CodeName.toLowerCase();
				}

				return className;
			},
			breadcrumb: function (item, url, title) {
	console.log(item);
				// get rid of first char - leading `/`. Then split based on `/`
				let urlStr = url.substr(1);
				let urlArr = urlStr.split('/');

				let crumbArr = [];
				for(let i = 0; i < urlArr.length; i ++) {
					let urlPath = '';
					urlPath += urlArr[i];
					const newStr = urlArr[i].replace(/-/g, ' ');
					crumbArr.push({
						url:  urlPath,
						title: newStr.replace(
							/\w\S*/g,
							function(txt) {
							  return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
							}
						)
					});
				}
				if(urlArr.length ===  0) {
					const newStr = title.replace(/-/g, ' ');

					crumbArr.push({
						url: url,
						title: title
					})
				}
				return crumbArr;
			},
			// Have to use a custom highlight filter because text-highlight doesn't work with v-html.
			// https://github.com/AlbertLucianto/vue-text-highlight/issues/48
			highlightText: function(str, queries) {
				console.log(queries);
				const query = queries[0];

				const check = new RegExp(query, 'ig');
				return str.toString().replace(check, function (matchedText, a, b){
					return (`<mark class="text__highlight">${ matchedText }</mark>`);
				});
				
			}
		}
    }
</script>